<template>
  <product-teasers-fi light />
</template>

<script setup lang="ts">
import ProductTeasersFi from '@/pages/product-teasers-fi/ProductTeasersFi.vue';

defineOptions({ name: 'ProductFamilyPreviewFi' });
</script>

<style scoped src="./product-family-preview-fi" />

<style src="./product-family-preview-fi-unscoped" />
